import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import { Config } from "@/config";
import { topRightList } from "./page-top-mack-data.js";
import { AccountStorage } from "@services/account";
import account from '@mixin/account';
import { mapGetters } from 'vuex';
var accountStorage = new AccountStorage();
export default {
  data: function data() {
    return {
      topRightList: topRightList,
      isShowCode: false,
      loginCompanyName: "",
      loginCompanyId: "",
      qrCodeUrl: "/pjyy-deepexi-aggregation/api/v1/qrcode/getQrCode?url=".concat(Config.env.VUE_APP_WEB_URL, "/pjyy-deepexi-aggregation/api/v1/qrcode/rouse?appId=__UNI__1DDC2C0"),
      isLoading: false,
      userList: [],
      isExternal: false,
      userName: '',
      dataList: {}
    };
  },
  mounted: function mounted() {
    var userInfo = accountStorage.getCacheUserInfo();
    if (userInfo) {
      this.loginCompanyName = userInfo.loginCompanyName;
      this.loginCompanyId = userInfo.loginCompanyId;
      this.isExternal = userInfo.type == 1 ? true : false;
      this.userName = userInfo.userName;
      this.getUserList();
      // this.getDataList()
    }
  },
  computed: _objectSpread({}, mapGetters(['iframeLogin'])),
  watch: {
    iframeLogin: function iframeLogin(value) {
      //插件登录，查询用户信息
      if (value) {
        var userInfo = accountStorage.getCacheUserInfo();
        if (userInfo) {
          this.loginCompanyName = userInfo.loginCompanyName;
          this.loginCompanyId = userInfo.loginCompanyId;
          this.isExternal = userInfo.type == 1 ? true : false;
          this.userName = userInfo.userName;
          console.log("userName", this.userName);
          this.getUserList();
          // this.getDataList()
        }
      }
    }
  },
  mixins: [account],
  methods: {
    getDataList: function getDataList() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$getHttpClient().post('/data-center/API_project/api_qianyi_env/default/adm_oms_count_today');
            case 2:
              result = _context.sent;
              _this.dataList = result.data.data[0];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    goLogin: function goLogin() {
      this.$router.push({
        name: "accountLogin"
      });
    },
    goFun: function goFun(index) {
      if (index === 0) {
        this.$router.push({
          path: "/user-center"
        });
      } else if (index === 1) {
        this.isShowCode = true;
      }
    },
    closeFun: function closeFun() {
      this.isShowCode = !this.isShowCode;
    },
    getUserList: function getUserList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var userList, URL, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              userList = accountStorage.getCacheUserList();
              if (!userList) {
                _context2.next = 5;
                break;
              }
              _this2.userList = userList;
              _context2.next = 10;
              break;
            case 5:
              URL = "/pjyy-deepexi-user-center/api/v1/company/getRelationAccountList?companyId=".concat(_this2.loginCompanyId);
              _context2.next = 8;
              return _this2.$getHttpClient().get(URL);
            case 8:
              result = _context2.sent;
              if (result.data.code === "200") {
                _this2.userList = result.data.data;
                accountStorage.setCacheUserList(result.data.data);
              }
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    onCheckUser: function onCheckUser(obj) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var URL, result;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoading = true;
              URL = "/pjyy-deepexi-user-center/api/v1/common/switchLoginAcc?companyId=".concat(obj.id);
              _context3.next = 4;
              return _this3.$getHttpClient().post(URL);
            case 4:
              result = _context3.sent;
              _this3.isLoading = false;
              if (result.data.code === "200") {
                accountStorage.setCacheUserInfo(result.data.data);
                accountStorage.removeCacheUserList();
                _this3.$router.push("/");
                _this3.reload();
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  },
  props: {
    isLogin: {
      type: Boolean,
      default: false
    }
  },
  inject: ["reload"]
};